import React from 'react'
import archivetick from '../../../src/component/enterprise-client/assets/archive-tick.svg';
import documenttxt from '../../../src/component/enterprise-client/assets/document-text.svg';
import ecLandingSection4Img from '../../../src/component/enterprise-client/assets/EC_LP Creatives2-01.svg';
import ecLandingSection5Img from '../../../src/component/enterprise-client/assets/EC_LP Creatives2-02.svg';
import ecLandingSection6Img from '../../../src/component/enterprise-client/assets/EC_LP Creatives2-03.svg';
import ecLandingSection7Img from '../../../src/component/enterprise-client/assets/EC_LP Creatives2-04.svg';
import eye from '../../../src/component/enterprise-client/assets/eye.svg';
import heart from '../../../src/component/enterprise-client/assets/heart.svg';
import message from '../../../src/component/enterprise-client/assets/message.svg';
import profile2 from '../../../src/component/enterprise-client/assets/profile-2user.svg';
import send2 from '../../../src/component/enterprise-client/assets/send-2.svg';
import timer from '../../../src/component/enterprise-client/assets/timer.svg';
// import asset19 from '../../../src/component/enterprise-client/assets/Asset 19.svg';
// import asset20 from '../../../src/component/enterprise-client/assets/Asset 20.svg';
// import asset22 from '../../../src/component/enterprise-client/assets/Asset 22.svg';
// import asset23 from '../../../src/component/enterprise-client/assets/Asset 23.svg';
// import asset24 from '../../../src/component/enterprise-client/assets/Asset 24.svg';
// import asset25 from '../../../src/component/enterprise-client/assets/Asset 25.svg';
// import asset26 from '../../../src/component/enterprise-client/assets/Asset 26.svg';
// import asset27 from '../../../src/component/enterprise-client/assets/Asset 27.svg';
// import asset28 from '../../../src/component/enterprise-client/assets/Asset 28.svg';
// import asset29 from '../../../src/component/enterprise-client/assets/Asset 29.svg';
// import asset30 from '../../../src/component/enterprise-client/assets/Asset 30.svg';
// import asset31 from '../../../src/component/enterprise-client/assets/Asset 31.svg';
// import asset32 from '../../../src/component/enterprise-client/assets/Asset 32.svg';
// import asset34 from '../../../src/component/enterprise-client/assets/Asset 34.svg';
// import asset35 from '../../../src/component/enterprise-client/assets/Asset 35.svg';
// import asset36 from '../../../src/component/enterprise-client/assets/Asset 36.svg';
// import asset37 from '../../../src/component/enterprise-client/assets/nYJtGp.tif (2).svg';
// import asset38 from '../../../src/component/enterprise-client/assets/yI9bh4.tif (2).svg';
// import Slider from 'react-slick';
// // import "slick-carousel/slick/slick.css";
// // import "slick-carousel/slick/slick-theme.css";
import { Typography } from '@mui/material';

function ECLandingSections() {
    const ecReadCaseNav = async () => {
        window.open("/blog", "_blank");
    }

    // const settingsRow1 = {
    //     dots: false,
    //     infinite: true,
    //     speed: 3000,
    //     slidesToShow: 5,
    //     slidesToScroll: 1,
    //     autoplay: true,
    //     autoplaySpeed: 0,
    //     cssEase: "linear",
    //     rtl: true,
    //     swipe: false,
    //     draggable: false,
    //     pauseOnHover: false,
    //     responsive: [
    //         {
    //             breakpoint: 768,
    //             settings: {
    //                 slidesToShow: 3,
    //             },
    //         },
    //         {
    //             breakpoint: 480,
    //             settings: {
    //                 slidesToShow: 2,
    //             },
    //         },
    //     ]
    // };

    // const settingsRow2 = {
    //     dots: false,
    //     infinite: true,
    //     speed: 3000,
    //     slidesToShow: 5,
    //     slidesToScroll: 1,
    //     autoplay: true,
    //     autoplaySpeed: 0,
    //     cssEase: "linear",
    //     rtl: false,
    //     swipe: false,
    //     draggable: false,
    //     pauseOnHover: false,
    //     responsive: [
    //         {
    //             breakpoint: 768,
    //             settings: {
    //                 slidesToShow: 3,
    //             },
    //         },
    //         {
    //             breakpoint: 480,
    //             settings: {
    //                 slidesToShow: 2,
    //             },
    //         },
    //     ]
    // };

    return (
        <>
            {/* START :: Empowering businesses around the world */}
            <section className="ec-landing-section-2">
                <div className="text-center text-2xl font-semibold">
                    Empowering businesses around the world
                </div>
                {/* <div className="slider-container">
                    <div className="slider-container-row">
                        <Slider {...settingsRow1}>
                            <img className='logo-img' src={asset19} alt='logo 1' />
                            <img className='logo-img' src={asset20} alt="logo 2" />
                            <img className='logo-img' src={asset22} alt="logo 3" />
                            <img className='logo-img' src={asset23} alt="logo 4" />
                            <img className='logo-img' src={asset24} alt="logo 5" />
                            <img className='logo-img' src={asset25} alt="logo 6" />
                            <img className='logo-img' src={asset26} alt="logo 7" />
                            <img className='logo-img' src={asset27} alt="logo 8" />
                            <img className='logo-img' src={asset28} alt="logo 9" />
                        </Slider>
                    </div>
                    <div className="row">
                        <Slider {...settingsRow2}>
                            <img className='logo-img' src={asset29} alt="logo 10" />
                            <img className='logo-img' src={asset30} alt="logo 11" />
                            <img className='logo-img' src={asset31} alt="logo 12" />
                            <img className='logo-img' src={asset32} alt="logo 13" />
                            <img className='logo-img' src={asset34} alt="logo 14" />
                            <img className='logo-img' src={asset35} alt="logo 15" />
                            <img className='logo-img' src={asset36} alt="logo 16" />
                            <img className='logo-img' src={asset37} alt="logo 17" />
                            <img className='logo-img' src={asset38} alt="logo 18" />
                        </Slider>
                    </div>
                </div> */}
                <div className="text-center">
                    <button className="bg-primaryPink text-white rounded-full pr-6 pl-6 pt-4 pb-4 w-44" onClick={ecReadCaseNav}>Read Case Studies</button>
                </div>
            </section >

            {/*START :: Numbers that Given proven Results: */}
            <div className="flex flex-col gap-10 items-center bg-section3BgColor xl:pt-16 xl:pb-16">
                <div className="flex gap-9 ">
                    <div className="border border-blackAlpha-10 shadow-section3BoxShadow rounded-section3BoxBorderRadius justify-center  xl:w-boxWidth xl:h-boxHeight flex flex-col items-center">
                        <div className='text-center pb-4'>
                            <img className='ec-landing-section-3-logo' src={eye} alt="eye img" />
                        </div>
                        <span className="xl:text-bodyText text-boxBodyTextcolor pb-2.5">Total Views</span>
                        <span className="xl:text-boxViewsTextSize xl:font-semibold">10M+</span>
                    </div>
                    <div className="border border-blackAlpha-10 shadow-section3BoxShadow rounded-section3BoxBorderRadius justify-center xl:w-boxWidth xl:h-boxHeight flex flex-col items-center">
                        <div className='text-center pb-4'>
                            <img className='ec-landing-section-3-logo' src={heart} alt="heart img" />
                        </div>
                        <span className="xl:text-bodyText text-boxBodyTextcolor pb-2.5">Total Likes</span>
                        <span className="xl:text-boxViewsTextSize xl:font-semibold">2.8K+</span>
                    </div>
                    <div className="border border-blackAlpha-10 shadow-section3BoxShadow rounded-section3BoxBorderRadius justify-center   xl:w-boxWidth xl:h-boxHeight flex flex-col items-center">
                        <div className='text-center pb-4'>
                            <img className='ec-landing-section-3-logo' src={message} alt="message img" />
                        </div>
                        <span className="xl:text-bodyText text-boxBodyTextcolor pb-2.5">Total Comments</span>
                        <span className="xl:text-boxViewsTextSize xl:font-semibold">8K+</span>
                    </div>
                    <div className="border border-blackAlpha-10 shadow-section3BoxShadow rounded-section3BoxBorderRadius justify-center   xl:w-boxWidth xl:h-boxHeight  flex flex-col items-center">
                        <div className='text-center pb-4'>
                            <img className='ec-landing-section-3-logo' src={send2} alt="send2 img" />
                        </div>
                        <span className="xl:text-bodyText text-boxBodyTextcolor pb-2.5">Total Shares</span>
                        <span className="xl:text-boxViewsTextSize xl:font-semibold">10K+</span>
                    </div>
                </div>
                <div className="flex gap-24">
                    <div className="border border-blackAlpha-10 shadow-section3BoxShadow rounded-section3BoxBorderRadius justify-center  xl:w-boxWidth xl:h-boxHeight  flex flex-col items-center">
                        <div className='text-center pb-4'>
                            <img className='ec-landing-section-3-logo' src={archivetick} alt="archivetick img" />
                        </div>
                        <span className="xl:text-bodyText text-boxBodyTextcolor pb-2.5">Total Saves</span>
                        <span className="xl:text-boxViewsTextSize xl:font-semibold">8K+</span>
                    </div>
                    <div className="border border-blackAlpha-10 shadow-section3BoxShadow rounded-section3BoxBorderRadius justify-center  xl:w-boxWidth  xl:h-boxHeight  flex flex-col items-center">
                        <div className='text-center pb-4'>
                            <img className='ec-landing-section-3-logo' src={timer} alt="timer img" />
                        </div>
                        <span className="xl:text-bodyText text-boxBodyTextcolor pb-2.5">Total Watch Times(Hrs)</span>
                        <span className="xl:text-boxViewsTextSize xl:font-semibold">136M Secs</span>
                    </div>
                    <div className="border border-blackAlpha-10 shadow-section3BoxShadow rounded-section3BoxBorderRadius justify-center   xl:w-boxWidth xl:h-boxHeight  flex flex-col items-center">
                        <div className='text-center pb-4'>
                            <img className='ec-landing-section-3-logo' src={profile2} alt="profile2 img" />
                        </div>
                        <span className="xl:text-bodyText text-boxBodyTextcolor pb-2.5">Numbers of Creators</span>
                        <span className="xl:text-boxViewsTextSize xl:font-semibold">500K+</span>
                    </div>
                    <div className="border border-blackAlpha-10 shadow-section3BoxShadow rounded-section3BoxBorderRadius justify-center   xl:w-boxWidth xl:h-boxHeight  flex flex-col items-center">
                        <div className='text-center pb-4'>
                            <img className='ec-landing-section-3-logo' src={documenttxt} alt="documenttxt img" />
                        </div>
                        <span className="xl:text-bodyText text-boxBodyTextcolor pb-2.5">Numbers of Content</span>
                        <span className="xl:text-boxViewsTextSize xl:font-semibold">500+</span>
                    </div>
                </div>
            </div>

            {/*START :: Find Your Ideal Creator for Your Brand*/}
            <section className="" >
                <div className="flex items-center  pl-containerPaddingLeft pr-containerPaddingRight pt-containerPaddingTop gap-section4Gap">
                    <div className="ec-landing-section-4-col-1">
                        <img className='ec-landing-section-4-img' src={ecLandingSection4Img} alt="ec-landing-section-4-img" />
                    </div>
                    <div className="ec-landing-section-col-2">
                        <span className="xl:text-heading1 font-semibold">
                            Find your <span style={{ color: '#F482C0' }}>Ideal Creator </span>for your<br></br> <span style={{ color: '#F482C0' }}>Brand</span>
                        </span>
                        <Typography className='xl:pt-10 '>
                            <ul>
                                <li className='list-disc'>
                                    <span className='xl:text-bodyText'>Discover the Ideal Creators and Achieve Campaign Success.</span>
                                </li>
                                <br></br>
                                <li className='list-disc'>
                                    <span className='xl:text-bodyText'> Utilize our affordable prices and complete campaign management to make smart choices.</span>
                                </li>
                            </ul>
                        </Typography>
                    </div>
                </div>
            </section >

            {/*START :: Find & Identify Your Ideal Creator Match*/}
            <section className="ec-landing-section-4" >
                <div className="flex items-center pl-containerPaddingLeft pr-containerPaddingRight pt-containerPaddingTop gap-section5Gap" >
                    <div className="">
                        <span className="xl:text-heading1 font-semibold">
                            Find &amp; Identify Your <span style={{ color: '#F482C0' }}>Ideal<br></br> Creator Match</span>
                        </span>
                        <Typography className='xl:pt-10 xl:text-bodyText'>
                            <ul>
                                <li className='list-disc'>
                                    <span className='xl:text-bodyText'>Explore a Range of Options: Demographics, Partnerships, Engagement, Content Affinity, Expert Support</span>
                                </li>
                                <br></br>
                                <li className='list-disc'>
                                    <span className='xl:text-bodyText'>Precision-Target Your Geographic Reach</span>
                                </li>
                                <br></br>
                                <li className='list-disc'>
                                    <span className='xl:text-bodyText'>Align with Creators Perfectly Suited to Your Brand</span>
                                </li>
                                <br></br>
                                <li className='list-disc'>
                                    <span className='xl:text-bodyText'>Drive Campaign Success with Data-Backed Decisions</span>
                                </li>
                            </ul>
                        </Typography>
                    </div>
                    <div className="ec-landing-section-4-col-1">
                        <img className='ec-landing-section-4-img' src={ecLandingSection5Img} alt="ec-landing-section-5-img" />
                    </div>
                </div>
            </section >

            {/*START :: Creator Recommendations from Past Data*/}
            <section className="ec-landing-section-4" >
                <div className="flex items-center pl-containerPaddingLeft pr-containerPaddingRight pt-containerPaddingTop gap-section6Gap">
                    <div className="ec-landing-section-4-col-1">
                        <img className='ec-landing-section-4-img' src={ecLandingSection6Img} alt="ec-landing-section-6-img" />
                    </div>
                    <div className="">
                        <span className="xl:text-heading1 font-semibold">
                            <span style={{ color: '#F482C0' }}>Creator Recommendations </span>from Past Data
                        </span>
                        <Typography className='xl:pt-10'>
                            <ul>
                                <li className='list-disc'>
                                    <span className='xl:text-bodyText'>Boost your creator selection with data-based recommendations.&nbsp;</span>
                                </li>
                                <br></br>
                                <li className='list-disc'>
                                    <span className='xl:text-bodyText'>Proactive suggestions based on successful past collaborations.</span>
                                </li>
                                <br></br>
                                <li className='list-disc'>
                                    <span className='xl:text-bodyText'>Identify creators with attributes similar to proven performers.&nbsp;</span>
                                </li>
                                <br></br>
                                <li className='list-disc'>
                                    <span className='xl:text-bodyText'>Optimize your influencer strategy with data-driven decision-making.</span>
                                </li>
                            </ul>
                        </Typography>
                    </div>
                </div>
            </section >

            {/*START :: Reporting & Recording of Every campaign */}
            <section className="ec-landing-section-4" >
                <div className="flex items-center pl-containerPaddingLeft pr-containerPaddingRight pt-containerPaddingTop pb-24 gap-section7Gap">
                    <div className="">
                        <span className="xl:text-heading1 font-semibold">
                            <span style={{ color: '#F482C0' }}>Reporting &amp; Recording </span>of Every campaign&nbsp;
                        </span>
                        <Typography className='xl:pt-10'>
                            <ul>
                                <li className='list-disc'>
                                    <span className='xl:text-bodyText'>Build every campaign based on sentiment analysis and content analysis.</span>
                                </li>
                                <br></br>
                                <li className='list-disc'>
                                    <span className='xl:text-bodyText'>Utilize data-driven insights for each content creator.</span>
                                </li>
                                <br></br>
                                <li className='list-disc'>
                                    <span className='xl:text-bodyText'>Optimize campaigns with detailed sentiment and content analysis.</span>
                                </li>
                            </ul>
                        </Typography>
                    </div>
                    <div className="ec-landing-section-4-col-1">
                        <img className='ec-landing-section-4-img' src={ecLandingSection7Img} alt="ec-landing-section-7-img" />
                    </div>
                </div>
            </section>
            <div className='ec-landing-section-padding'></div>
        </>
    )
}

export default ECLandingSections;
